/** Активности с модальным окном */
export const OPEN_SUPPORT_WINDOW = 'OPEN_SUPPORT_WINDOW';
export const OPEN_SUPPORT_WINDOW_SUCCESS = 'OPEN_SUPPORT_WINDOW_SUCCESS';
export const OPEN_SUPPORT_WINDOW_FAIL = 'OPEN_SUPPORT_WINDOW_FAIL';
export const CLOSE_SUPPORT_WINDOW = 'CLOSE_SUPPORT_WINDOW';
export const SET_SUPPORT_INFO = 'SET_SUPPORT_INFO';
/** Получить номер обращения */
export const GET_SUPPORT_NEXT_NUMBER = 'GET_SUPPORT_NEXT_NUMBER';
export const GET_SUPPORT_NEXT_NUMBER_SUCCESS = 'GET_SUPPORT_NEXT_NUMBER_SUCCESS';
export const GET_SUPPORT_NEXT_NUMBER_FAIL = 'GET_SUPPORT_NEXT_NUMBER_FAIL';
/** Добавление фото */
export const SUPPORT_ADD_PHOTO = 'SUPPORT_ADD_PHOTO';
export const SUPPORT_ADD_PHOTO_SUCCESS = 'SUPPORT_ADD_PHOTO_SUCCESS';
export const SUPPORT_ADD_PHOTO_FAIL = 'SUPPORT_ADD_PHOTO_FAIL';
/** Удаление фото */
export const SUPPORT_DEL_PHOTO = 'SUPPORT_DEL_PHOTO';
export const SUPPORT_DEL_PHOTO_SUCCESS = 'SUPPORT_DEL_PHOTO_SUCCESS';
export const SUPPORT_DEL_PHOTO_FAIL = 'SUPPORT_DEL_PHOTO_FAIL';
/** Отправка сообщения */
export const SUPPORT_SEND_EMAIL = 'SUPPORT_SEND_EMAIL';
export const SUPPORT_SEND_EMAIL_SUCCESS = 'SUPPORT_SEND_EMAIL_SUCCESS';
export const SUPPORT_SEND_EMAIL_FAIL = 'SUPPORT_SEND_EMAIL_FAIL';
/** Список фотографий */
export const SUPPORT_GET_LIST_PHOTOS = 'SUPPORT_GET_LIST_PHOTOS';
export const SUPPORT_GET_LIST_PHOTOS_SUCCESS = 'SUPPORT_GET_LIST_PHOTOS_SUCCESS';
export const SUPPORT_GET_LIST_PHOTOS_FAIL = 'SUPPORT_GET_LIST_PHOTOS_FAIL';
/** Удалить номер обращения */
export const DEL_SUPPORT_NUMBER = 'DEL_SUPPORT_NUMBER';
